import { useEffect, useRef, useState } from "react";
import { RegulifyService } from "../api/RegulifyService";

import { useShallow } from "zustand/react/shallow";
import { useLoading } from "../context/LoadingContext";
import { useChatStore } from "../store/useChatStore";
import Message from "./Message";

const Chat = ({ isDocIndexed = false }) => {
  const messages = useChatStore(useShallow((state) => state.botMessages));
  const indexedFile = useChatStore(useShallow((state) => state.indexedFile));
  const newMessage = useChatStore((state) => state.newBotMessage);
  const removeIndexedFile = useChatStore((state) => state.removeIndexedFile);
  const [input, setInput] = useState("");
  const [includePMAColl, setPMACollFlag] = useState(false);
  const chatRef = useRef(null);

  const { setLoading } = useLoading();

  const sendMessage = async (ev) => {
    ev.preventDefault();
    if (!input.trim()) return;

    const userMessage = {
      text: input,
      sender: "Human",
      isDocIndexedChat: isDocIndexed,
    };
    newMessage(userMessage);

    try {
      const setCollTypeModel = includePMAColl
        ? "FDA_PMA_GUIDELINE_GPT_1024"
        : "FDA_CFRTITLE21_CHAPT_H_GPT_1024";

      setLoading(true);
      const response = isDocIndexed
        ? await RegulifyService.chat_doc_sme(//For DocSME
            input,
            "",
          )
        : await RegulifyService.chat_regu_bot(//For ReguBot (both with/without PMA flag)
            input,
            setCollTypeModel,
          );

      const botMessage = {
        text: response.data,
        sender: "Bot",
        isDocIndexedChat: isDocIndexed,
      };

      newMessage(botMessage);
    } catch (error) {
      console.error("Error:", error);
      const errorMessage = {
        text: "Failed to get a response. Please try again.",
        sender: "Bot",
        isDocIndexedChat: isDocIndexed,
      };
      newMessage(errorMessage);
    }
    setLoading(false);
    setInput("");
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="flex h-[calc(100vh-180px)] w-full flex-col">
      <div className="flex-1 overflow-hidden">
        <div className="card bg-base-100 mt-1 flex h-full flex-col overflow-hidden p-1 shadow-xl">
          <div
            ref={chatRef}
            className="flex-1 space-y-2 overflow-y-auto p-2"
            style={{ scrollBehavior: "smooth" }}
          >
            {messages
              .filter((msg) => msg.isDocIndexedChat === isDocIndexed)
              .map((msg, index) => (
                <Message text={msg.text} sender={msg.sender} key={index} />
              ))}
            <div className="h-2"></div>
          </div>
        </div>
      </div>

      <div className="flex-shrink-0 p-2">
        <form onSubmit={sendMessage}>
          <fieldset className="fieldset bg-base-200 border-base-300 rounded-box w-full border p-4">
            {!isDocIndexed && (
              <>
                <label className="fieldset-label">
                  To optimize AI understanding, specify FDA medical device
                  regulations like '876.1500' in SINGLE QUOTES. For example:
                  What are the major differences between regulations '876.1500'
                  and '876.1800' per FDA?
                </label>
                <label
                  className="label tooltip tooltip-top mt-2 cursor-pointer"
                  data-tip="Check this option if applicable to PMA (Pre-Market Approval) device types"
                >
                  <input
                    type="checkbox"
                    className="checkbox checkbox-primary mr-2"
                    checked={includePMAColl}
                    onChange={(e) => setPMACollFlag(e.target.checked)}
                  />
                  <span className="label-text">
                    Is this query related to PMA types of devices?
                  </span>
                </label>
              </>
            )}
            {isDocIndexed && (
              <label className="fieldset-label">
                You can query <strong>{indexedFile.fileName}</strong> or{" "}
                <a className="link" onClick={() => removeIndexedFile()}>
                  upload a different document
                </a>
              </label>
            )}
            <div className="join">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className="input join-item flex-1"
                placeholder="Type your message..."
              />
              <button className="btn join-item" type="submit">
                Send
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
};
export default Chat;
